import * as types from './mutation-types';

const mutataions = {
    [types.SET_USERINFO](state, userInfo) {
        state.userInfo = userInfo;
    },
    [types.SET_BALANCE](state, balance) {
        state.balance = balance;
    },
    [types.SET_PENGING](state, pending) {
        if (!pending) {
            state.pending = 0;
        } else {
            state.pending = pending;
        }
    },
    [types.SET_TODAYRATE](state, todayRate) {
        state.todayRate = todayRate;
    },
    [types.SET_PENDING](state, pending) {
        state.pending = pending;
    }
}
export default mutataions;